import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Router } from "@angular/router";
import { SelectMenuOption } from "../../../form/select-menu/select-menu.component";
import { RowEventEmit } from "../../events-screen/event-page-models/row-event-emit";

import { trimTextByWord } from "../../events-screen/utils/trimTextByWord";
import { GeneralRowEvent } from "../../../_models/general-row-event";
import { AppUserModel } from "../user-management-models/app-user.model";
import { UserEditPermissionLevel } from "../user-management-models/user-privilege-edit-type.enum";

@Component({
  selector: "user-management-row",
  templateUrl: "./user-management-row.component.html",
  styleUrls: ["./user-management-row.component.scss"],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          maxHeight: "1500px",
          opacity: 1,
          overflow: "visible",
        })
      ),
      state(
        "closed",
        style({
          maxHeight: "1px",
          height: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class UserManagementRowComponent implements OnInit, OnDestroy {
  @Input("isSelected") public isSelected: boolean;
  @Output("rowEvent") public rowEvent: EventEmitter<
    GeneralRowEvent<AppUserModel>
  > = new EventEmitter<GeneralRowEvent<AppUserModel>>();
  public readonly UserEditPermissionLevel = UserEditPermissionLevel;

  public eventStatusMenuOptions: SelectMenuOption[] = [
    {
      icon: "",
      key: "open",
      text: "פתוח",
      customValue: "",
    },
    {
      icon: "",
      key: "closed",
      text: "סגור",
      customValue: "",
    },
  ];
  public parentEventStatus: SelectMenuOption = this.eventStatusMenuOptions[0];
  public calculateUserManagementMenuOptions: Array<{
    action: string;
    text: string;
    customIcon?: string;
  }> = [];
  private baseUserManagementMenuOptions: Array<{
    action: string;
    text: string;
    customIcon?: string;
  }> = [
    {
      action: "editActivityFields",
      text: "עריכת שדה פעילות",
      customIcon: "editActivityFields",
    },
  ];

  constructor(
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  public _appUser: AppUserModel;

  @Input() public set appUser(value: AppUserModel) {
    if (!value) {
      return;
    }
    this._appUser = value;
    this.calculateUserManagementMenuOptionsByUser();
  }

  public ngOnInit(): void {}

  ngOnDestroy(): void {}

  public formatDate(date: Date | any) {
    if (!date) {
      return "ללא";
    }
    return `${date.getDate()}.${date.getMonth() + 1}.${
      date.getFullYear() - 2000
    }`;
  }

  clickSelect($event: Event) {
    $event.stopPropagation();
    $event.stopPropagation();
  }

  public rowClicked($event): void {
    if (this._appUser.canEditPermissionLevel !== "edit_details") {
      return;
    }

    const action = !this.isSelected ? "select" : "unselect";
    this.rowEvent.emit({
      action,
      eventId: this._appUser.id.toString(),
      eventObject: this._appUser,
    });
  }

  public changeStatus($event: any) {}

  public menuEventHandler($event: RowEventEmit) {
    // tslint:disable-next-line:no-object-literal-type-assertion
    this.rowEvent.emit({
      action: $event.action,
      eventId: this._appUser.id.toString(),
      eventObject: this._appUser,
    } as GeneralRowEvent<AppUserModel>);
  }

  public trimText(text: string, maxlength = 14) {
    return trimTextByWord(text, maxlength);
  }

  private calculateUserManagementMenuOptionsByUser() {
    let editUSerOptions = [];
    const addedOptions = !this._appUser.isActive
      ? {
          action: "setActive",
          text: "סימון כפעיל",
          customIcon: "setActive",
        }
      : {
          action: "setInActive",
          text: "סימון כלא פעיל",
          customIcon: "setInActive",
        };
    if (
      this._appUser.canEditPermissionLevel ===
      UserEditPermissionLevel.EditDetails
    ) {
      editUSerOptions = [
        {
          action: "edit",
          text: "עריכת פרופיל משתמש",
          customIcon: "editUserProfile",
        },
        addedOptions,
        {
          action: "resetPassword",
          text: "איפוס סיסמה",
          customIcon: "resetPassword",
        },
      ];
    }
    this.calculateUserManagementMenuOptions = [
      ...this.baseUserManagementMenuOptions,
      ...editUSerOptions,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-row/user-management-row.component.ts